import NodeRSA from 'node-rsa';
import {acceptanceCashMovementConfig} from 'pages/acceptanceCashMovement';
import {acceptanceCashReturnConfig} from 'pages/acceptanceCashReturn';
import {authRole} from '../../shared/constants/AppEnums';
import {cashDeliveryConfig} from 'pages/cashDelivery';
import {cashReplenishmentSortasiConfig} from 'pages/orderCashReplenishmentSortasi';
import {citCheckinCashReplenishmentConfig} from 'pages/serviceCashReplenishment';
import {cpcTujuanConfig} from 'pages/cpcTujuan';
import {cpcVaultingCashPickUpConfig} from 'pages/cpcVaultingCashPickUp';
import {cpcVaultingCashReplenishment} from 'pages/cpcVaultingCashReplenishment';
import {dashboardConfig} from '../../pages/dashboard';
import {menuList} from '../../pages';
import moment from 'moment';
import momentTz from 'moment-timezone';
import {orderCashMovementConfig} from 'pages/orderCashMovement';
import {orderCashPickUpConfig} from 'pages/orderCashPickup';
import {orderCashPickUpSortasiConfig} from 'pages/orderCashPickupSortasi';
import {orderCashReplenishmentConfig} from 'pages/orderCashReplenishment';
import {orderReturnAssignConfig} from 'pages/orderCashReturn';
import {orderReturnCheckInConfig} from 'pages/orderCashReturnCheckIn';
import {orderReturnNoSealConfig} from 'pages/orderCashReturnNoSeal';
import {pendingTaskConfig} from 'pages/pendingTask2';
import {reapairNoSealCashReturnConfig} from 'pages/repairSealCashReturn';
import {reportMenuConfig} from 'pages/reportMenu';
import {serviceCashDeliveryConfig} from 'pages/serviceCashDelivery';
// import {serviceCashMovementAcceptanceConfig} from 'pages/serviceCashMovementAccept';
import {serviceCashMovementNoSealConfig} from 'pages/serviceCashMovementNoSeal';
import {serviceCashPickUpConfig} from 'pages/serviceCashPickUp';
import {uangDiragukanConfig} from 'pages/uangDiragukan';
import {uangDiragukanReplenishmentConfig} from 'pages/uangDiragukanReplenishment';
import {updateCompanyConfig} from 'pages/settingParameter';
import {useIntl} from 'react-intl';
import {userManagementConfig} from 'pages/userManagement';
import {orderCashReplenishmentPembukuanConfig} from 'pages/orderCashReplenismentPembukuan';
import {vendorChargeConfig} from 'pages/vendorCharge';
import {orderCashReturnPembukuanConfig} from 'pages/orderCashReturnPembukuan';
import CryptoJS from 'crypto-js';

//import {serviceCashReplenishmentConfig} from 'pages/serviceCashReplenishment';
// import {serviceCashMovementAcceptanceConfig} from 'pages/serviceCashMovementAccept';
// import {serviceCashReplenishmentConfig} from 'pages/serviceCashReplenishment';

export const getCustomDateTime = (
  value = 0,
  unit = 'days',
  format = 'YYYY-MM-DD',
) => {
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment().add(value, unit).format(format);
  }
};

export const getTimeFromNow = (date) => {
  const timestamp = moment(date).format('X');
  const newDate = moment.unix(timestamp);
  return moment(newDate).fromNow();
};

// 'intl' service singleton reference
let intl;

export function IntlGlobalProvider({children}) {
  intl = useIntl();
  // Keep the 'intl' service reference
  return children;
}

export const appIntl = () => {
  return intl;
};

export const isRequestSuccessful = (code) => {
  return code >= 200 && code <= 204;
};

export const checkPermission = (routeAuth, userRole) => {
  if (routeAuth === null || routeAuth === undefined) {
    return true;
  }

  if (userRole && Array.isArray(userRole)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0);
  }

  if (routeAuth.length === 0) {
    return !userRole || userRole.length === 0;
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeAuth)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0);
  }
  return routeAuth.indexOf(userRole) >= 0;
};

export const getFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  let k = 1024,
    dm = 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const multiPropsFilter = (products, filters, stringKey = 'title') => {
  const filterKeys = Object.keys(filters);
  return products.filter((product) => {
    return filterKeys.every((key) => {
      if (!filters[key].length) return true;
      // Loops again if product[key] is an array (for material attribute).
      if (Array.isArray(product[key])) {
        return product[key].some((keyEle) => filters[key].includes(keyEle));
      }
      if (key === stringKey) {
        return product[key].toLowerCase().includes(filters[key].toLowerCase());
      }
      return filters[key].includes(product[key]);
    });
  });
};
export const generateUniqueID = () => {
  return `v1-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

export const getUserFromJwtAuth = (user) => {
  if (user)
    return {
      id: user.id,
      uid: user.id || null,
      displayName: user.name,
      email: user.email,
      photoURL: user.avatar || null,
      role: authRole.user,
    };
  return user;
};

export const getStringFromHtml = (htmlContent) => {
  return htmlContent.replace(/(<([^>]+)>)/gi, '');
};

export function encryptPassword(message, publicKey) {
  const keys = new NodeRSA(publicKey, 'pkcs8-public');
  keys.setOptions({
    encryptionScheme: 'pkcs1',
  });
  return keys.encrypt(message, 'base64');
}

export function prepareAuthentication(username, password, pkey) {
  if (username && password && pkey) {
    const encryptedPass = encryptPassword(password, pkey);
    const authNaked = `${username}:${encryptedPass}`;
    const authEncrypted = btoa(authNaked);
    return 'basic ' + authEncrypted;
  }
  return null;
}

export function parseJwt(token) {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export function constructMenu(listData) {
  listData.push(
    'MNU_HOME',
    'GROUP_USER_MANAGEMENT',
    'GROUP_CASH_PICKUP',
    'GROUP_CASH_MOVEMENT',
    'GROUP_CASH_RETURN',
    'GROUP_UANG_DIRAGUKAN',
    'MNU_EXAMPLE',
    'MNU_CHECKIN_ACCEPTANCE_CASH_PICKUP',
    'MNU_UANG_DIRAGUKAN_CASH_PICKUP',
    'MNU_ORDER_CASH_MOVEMENT',
    'MNU_CPC_CASH_REPLENISHMENT',
    'GROUP_CASH_MOVEMENT',
    'MNU_VAULTING_CASH_MOVEMENT',
    'MNU_ORDER_CASH_REPLENISHMENT',
    'MNU_ORDER_CASH_RETURN_ASSIGN_PIC',
    'MNU_SERVICE_CASH_RETURN_SEAL_NO',
    'MNU_SERVICE_CASH_RETURN_CHECK_IN',
    'MNU_UANG_DIRAGUKAN_CASH_REPLENISHMENT',
    'GROUP_CASH_PICKUP',
    'GROUP_CASH_DELIVERY',
    'GROUP_CASH_MOVEMENT',
    'GROUP_CASH_RETURN',
    'GROUP_CASH_REPLENISHMENT',
    'MNU_VENDOR_PENDING_TASK',
    'MNU_VENDOR_USER_MANAGEMENT',
    'MNU_ORDER_CASH_PICKUP',
    'MNU_CHECKIN_ACCEPTANCE_CASH_PICKUP',
    'MNU_VAULTING_CASH_PICKUP',
    'MNU_SORTASI_CASH_PICKUP',
    'MNU_UANG_DIRAGUKAN_CASH_PICKUP',
    'MNU_VENDOR_MANAGEMENT',
    'MNU_ORDER_CASH_DELIVERY',
    'MNU_CPC_ORDER_CASH_DELIVERY',
    'MNU_CHECKIN_SENDING_CASH_DELIVERY',
    'MNU_ORDER_CASH_MOVEMENT',
    'MNU_ORDER_CASH_MOVEMENT_DESTINATION',
    'MNU_INPUT_SEAL_NO_CASH_MOVEMENT',
    'MNU_ACCEPTANCE_CASH_MOVEMENT',
    'MNU_ORDER_CASH_REPLENISHMENT',
    'MNU_CHECKIN_CASH_REPLENISHMENT',
    'MNU_CPC_CASH_REPLENISHMENT',
    'MNU_CPC_CASH_REPLENISHMENT_PEMBUKUAN',
    'MNU_VAULTING_CASH_MOVEMENT',
    'MNU_SERVICE_CASH_RETURN_ACCEPTANCE',
    'MNU_ORDER_CASH_RETURN_ASSIGN_PIC',
    'MNU_SERVICE_CASH_RETURN_ACCEPTANCE',
    'MNU_SERVICE_CASH_RETURN_CHECK_IN',
    'MNU_SERVICE_CASH_RETURN_COMPLETE',
    'MNU_SERVICE_CASH_RETURN_REPAIR_SEAL_NO',
    'MNU_SERVICE_CASH_RETURN_SEAL_NO',
    'MNU_UANG_DIRAGUKAN_CASH_REPLENISHMENT',
    'MNU_SORTATION_CASH_REPLENISHMENT',
    'MNU_SERVICE_CASH_RETURN_SEAL_NO',
    'MNU_VENDOR_MANAGEMENT',
    'MNU_REPORT',
    'MNU_REPORT_VENDOR_BRANCH',
    'MNU_REPORT_VENDOR_HQ',
    'GROUP_VENDOR_CHARGE',
    'MNU_CHARGE_TRANSPORT',
    'MNU_CHARGE_SORTATION',
    'MNU_SERVICE_CASH_RETURN_PEMBUKUAN',
  );
  listData.forEach((item) => {
    switch (item) {
      case 'MNU_HOME':
        menuList.routes.push(...dashboardConfig);
        menuList.routes.push(...userManagementConfig);
        menuList.routes.push(...orderCashPickUpConfig);
        menuList.routes.push(...cashDeliveryConfig);
        menuList.routes.push(...serviceCashDeliveryConfig);
        menuList.routes.push(...cpcVaultingCashPickUpConfig);
        menuList.routes.push(...orderCashPickUpSortasiConfig);
        menuList.routes.push(...serviceCashPickUpConfig);
        menuList.routes.push(...uangDiragukanConfig);
        menuList.routes.push(...orderCashMovementConfig);
        menuList.routes.push(...serviceCashMovementNoSealConfig);
        menuList.routes.push(...orderCashReplenishmentConfig);

        // menuList.routes.push(...serviceCashMovementAcceptanceConfig);
        menuList.routes.push(...orderReturnAssignConfig);
        menuList.routes.push(...orderReturnNoSealConfig);
        menuList.routes.push(...orderReturnCheckInConfig);
        menuList.routes.push(...uangDiragukanReplenishmentConfig);

        // menuList.routes.push(...serviceCashMovementAcceptanceConfig);
        // menuList.routes.push(...serviceCashReplenishmentConfig);
        menuList.routes.push(...pendingTaskConfig);
        // menuList.routes.push(...serviceCashMovementAcceptanceConfig);
        menuList.routes.push(...cpcVaultingCashReplenishment);
        menuList.routes.push(...cashReplenishmentSortasiConfig);
        menuList.routes.push(...cpcTujuanConfig);
        menuList.routes.push(...reapairNoSealCashReturnConfig);
        menuList.routes.push(...updateCompanyConfig);
        menuList.routes.push(...citCheckinCashReplenishmentConfig);
        menuList.routes.push(...vendorChargeConfig);
        menuList.routes.push(...reportMenuConfig);
        menuList.routes.push(...orderCashReplenishmentPembukuanConfig);
        menuList.routes.push(...orderCashReturnPembukuanConfig);
        break;
      case 'MNU_SERVICE_CASH_RETURN_ACCEPTANCE':
        menuList.routes.push(...acceptanceCashReturnConfig);
        break;
      case 'MNU_ACCEPTANCE_CASH_MOVEMENT':
        menuList.routes.push(...acceptanceCashMovementConfig);
        break;
    }
  });

  // filterObject(routeConfig, listData);
}

// export function filterObject(obj, listMenu) {
//   const idx = obj.findIndex((v) => !listMenu.includes(v.id));
//   obj.splice(idx, idx >= 0 ? 1 : 0);
//   obj.forEach((menuItem) => {
//     if (menuItem.group) {
//       let group = menuItem.group;
//       const idx2 = group.findIndex((v) => !listMenu.includes(v.id));
//       group.splice(idx2, idx2 >= 0 ? 1 : 0);
//       if (group.length == 0) {
//         const idxGroup = obj.findIndex((v) => v.id === menuItem.id);
//         obj.splice(idxGroup, idx >= 0 ? 1 : 0);
//       }
//     }
//   });
//   console.log(obj);
// }

export function moneyFormat(amount, curr, mfd) {
  const formatter = new Intl.NumberFormat('en-US', {
    currency: curr || 'IDR',
    minimumFractionDigits: mfd || 0,
  });
  if (curr) {
    return curr + ' ' + formatter.format(Number(amount));
  }

  if (mfd) {
    return formatter.format(Number(amount));
  }

  return Number(amount).toLocaleString('en-US', {
    ...formatter,
    style: 'decimal',
  });
}

export function moneyFormatIDR(number, decimalPoint) {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    currencyDisplay: 'code',
    maximumSignificantDigits: 3,
    minimumFractionDigits: decimalPoint || 0,
  });

  if (number) return formatter.format(parseToNumber(number));
  else return '-';
}

export function parseToNumber(strAmount) {
  if (
    (typeof strAmount === 'number' ||
      (typeof strAmount === 'string' && strAmount.trim() !== '')) &&
    !isNaN(strAmount)
  ) {
    const value = strAmount.replaceAll(/\./g, '').replaceAll(' ', '');
    return Number(value.replace(/,/g, '.'));
  } else {
    return strAmount;
  }
}

export function parseToNumber2(number) {
  let temp = number.split('.').join('');
  return Number(temp);
}

export function removeSuffixOrPrefix(value, strRemove) {
  if (isNaN(value)) {
    return parseToNumber(value.replaceAll(strRemove, ''));
  } else {
    return value;
  }
}

export function getTimeFormatByTZ() {
  const currentTz = momentTz.tz.guess();
  let formatTime = '';
  switch (currentTz) {
    case 'Asia/Jayapura':
      formatTime = 'HH:mm [WIT]';
      break;
    case 'Asia/Makassar':
      formatTime = 'HH:mm [WITA]';
      break;
    default:
      formatTime = 'HH:mm [WIB]';
  }
  return formatTime;
}

export function saveFile(filename, data) {
  const blob = new Blob([data], {type: 'text/csv'});
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}

export function base64toFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type: mime});
}

export const specialCharacterChange = (evt) => {
  const charCode = evt.which ? evt.which : evt.keyCode;
  const isShiftPressed = evt.nativeEvent.shiftKey;
  const isCtrlPressed = evt.ctrlKey;
  if (isShiftPressed) {
    if (
      (charCode > 47 && charCode < 58) ||
      (charCode > 185 && charCode < 193) ||
      (charCode > 218 && charCode < 223)
    )
      return evt.preventDefault();
  } else {
    if (
      isCtrlPressed &&
      (charCode === 86 || charCode === 67 || charCode === 65)
    ) {
      return true;
    } else if (
      (charCode > 185 && charCode < 193) ||
      (charCode > 218 && charCode < 223) ||
      (charCode === 32 && evt.target.selectionStart === 0)
    ) {
      return evt.preventDefault();
    }
    return true;
  }
  return true;
};

export const specialCharacterChange2 = (evt) => {
  const charCode = evt.which ? evt.which : evt.keyCode;
  const isShiftPressed = evt.nativeEvent.shiftKey;
  const isCtrlPressed = evt.ctrlKey;
  if (isShiftPressed) {
    if (
      (charCode > 47 && charCode < 58) ||
      (charCode > 185 && charCode < 193) ||
      (charCode > 218 && charCode < 223)
    )
      return evt.preventDefault();
  } else {
    if (
      isCtrlPressed &&
      (charCode === 86 || charCode === 67 || charCode === 65)
    ) {
      return true;
    } else if (
      (charCode > 185 && charCode < 193) ||
      (charCode > 218 && charCode < 223) ||
      (charCode === 32 && evt.target.selectionStart === 0) ||
      charCode === 32
    ) {
      return evt.preventDefault();
    }
    return true;
  }
  return true;
};

export const getTimeZoneLocal = (date) => {
  if (date) {
    const newDate = new Date(date);
    const longDate = new Intl.DateTimeFormat('id-ID', {
      dateStyle: 'full',
      timeStyle: 'long',
    }).format(newDate);

    const tz = longDate.split(' ');
    const tzIndo = tz[tz.length - 1];

    if (tzIndo === 'GMT+7') {
      return 'WIB';
    } else if (tzIndo === 'GMT+8') {
      return 'WITA';
    } else if (tzIndo === 'GMT+9') {
      return 'WIT';
    } else {
      return tzIndo;
    }
  } else {
    return 'WIB';
  }
};

export const hashSHA512 = () => {
  var result = '';
  let finalKey = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < 15; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  let final = result !== null ? CryptoJS.SHA512(result).toString() : null;

  if (localStorage.getItem('hshk') === null) {
    finalKey = final;
    localStorage.setItem('hshk', finalKey);
  } else {
    finalKey = localStorage.getItem('hshk');
  }

  return finalKey;
};

// Repair No Seal
export const isEmptyField = (seal) => {
  for (let i = 0; i < seal.length; i++) {
    if (seal[i].sealNewNo === '' || seal[i].sealNewNo[0] === ' ') {
      return true;
    }
  }
  return false;
};

export const isNewSealSameAsOldSeal = (listAllSeal, sendSeal) => {
  const oldSeal = [];

  for (let i = 0; i < listAllSeal.length; i++) {
    oldSeal.push(listAllSeal[i].sealNo.toLowerCase());
  }

  for (let i = 0; i < sendSeal.length; i++) {
    if (oldSeal.includes(sendSeal[i].sealNewNo.toLowerCase())) {
      return true;
    }
  }
  return false;
};

export const handleAlertSameInputSeal = (
  newSeal,
  idx,
  sendSeal,
  listAllSeal,
) => {
  const sealFind = sendSeal.find((e, index) => {
    return e.sealNewNo.toLowerCase() === newSeal.toLowerCase() && idx !== index;
  });

  if (sealFind !== undefined && newSeal !== '') {
    return true;
  }

  for (let i = 0; i < listAllSeal.length; i++) {
    if (listAllSeal[i].sealNo.toLowerCase() === newSeal.toLowerCase()) {
      return true;
    }
  }
  return false;
};

export const isInputNewSealSame = (sendSeal) => {
  const newSeal = [];
  for (let i = 0; i < sendSeal.length; i++) {
    if (!newSeal.includes(sendSeal[i].sealNewNo.toLowerCase())) {
      newSeal.push(sendSeal[i].sealNewNo.toLowerCase());
    }
  }
  return newSeal.length !== sendSeal.length;
};

export function isShowRecaptcha(value) {
  const reCaptcha = document.querySelector('.grecaptcha-badge');
  if (!value && reCaptcha) {
    reCaptcha.style.visibility = 'hidden';
  }
  if (value && reCaptcha) {
    reCaptcha.style.removeProperty('visibility');
  }
}

export function resetEventBack(val) {
  for (let i = 0; i < val; i++) {
    window.history.back();
  }
}
